const baseURL = "/v1/MaterialFormacao";

const service = {
  methods: {
    $buscar(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizar(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $cadastrar(formacaoId, body) {
      return this.$api().post(`${baseURL}/${formacaoId}`, body);
    },
    $editar(id, body) {
      return this.$api().patch(`${baseURL}/${id}`, body);
    },
    $excluir(id) {
      return this.$api().delete(`${baseURL}/${id}`);
    },
    $baixar(id) {
      return this.$api().post(`${baseURL}/${id}/baixar`);
    },
    $baixarMaterialZip(id) {
      return this.$api().get(`${baseURL}/BaixarArquivos/${id}`, {responseType: 'blob'});
    },
    $listarBancoDeMaterial(params) {
      return this.$api().get(`${baseURL}/BancoDeMaterial`, params);
    }
  },
};

export default service;